import React, { Component } from 'react';
import { Input, Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';
import InputTilePopoverCard from './InputTilePopoverCard';
import { connect } from 'react-redux';
import { modalActions, inputTilesActions, retirementAgeActions } from '../../redux/root-action';
import { modals, analyticsTracking } from '../../utils/constants';
import { getRetirementAgeAdvice } from '../../selectors';
import { keyDown } from '../../utils/helpers';

const TileHeaderTitle = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  letter-spacing: -0.3px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
`;

const TileSubheader = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey700};
  padding-bottom: 16px;
  letter-spacing: 0.4px;
  border-bottom: 1px solid ${tokens.ColorWhite200};
  margin-bottom: 24px;
`;

const Divider = styled.div`
  height: 1px;
  overflow: hidden;
  width: 100%;
  background-color: ${tokens.ColorWhite100};
  margin-top: 24px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

const AgeRangeContainer = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  flex-wrap: wrap;
  width: 100%
  justify-content: space-between;
`;

const TextContainer = styled.div`
  margin-top: 12px;
  color: ${tokens.ColorGrey900};
`;

const InputsContaioner = styled.div`
  display: flex;
  flex: 1;
  justify-content: right;
`;

const LabelContainer = styled.div`
  margin-top: 12px;
  display: inline;
  color: ${tokens.ColorGrey800};
`;

const InputWithMessage = styled.div`
  width: 72px;
  > div {
    width: auto !important;
    > div {
      height: 36px;
    }
    input {
      width: 56px !important;
      padding: 0;
      margin: 0 0 0 16px !important;
    }
  }
`;

const InputMessage = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  text-align: center;
  margin-top: 8px;
`;

const LabelMessage = styled.div`
  font-family: 'Nimbus Sans Regular';
  font-size: 14px;
  line-height: 18px;
  font-style: italic;
  color: ${tokens.ColorGrey700};
  margin-top: 8px;
`;

const StyledError = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  display: block;
  white-space: pre-wrap;
  color: ${tokens.ColorFunctionalRed700};
  margin-top: 16px;
`;

class RetirementAge extends Component<any> {
  props: any;
  state: any;

  showRetirementAgeModal = () => {
    const { showModal } = this.props;
    showModal(modals.RETIREMENT_AGE);
  };

  handleCancel = () => {
    const { updateRetirementAgeData, updateRetirementAgeError, hideInputTilePopover, retirementAge } = this.props;
    updateRetirementAgeData(retirementAge.modelledScenario);
    updateRetirementAgeError({
      hasParticipantStartError: false,
      hasParticipantEndError: false,
      participantErrorMessage: '',
      hasSpouseError: false,
      spouseErrorMessage: '',
    });
    hideInputTilePopover();
  };

  particStartInputAllowNumbersOnly = (e: any) => {
    const { updateRetirementAgeData } = this.props;
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      updateRetirementAgeData({
        retirementStartAge: Number(e.target.value),
      });
    }
  };

  particEndInputAllowNumbersOnly = (e: any) => {
    const { updateRetirementAgeData } = this.props;
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      updateRetirementAgeData({
        retirementEndAge: Number(e.target.value),
      });
    }
  };

  spouseInputAllowNumbersOnly = (e: any) => {
    const { updateRetirementAgeData } = this.props;
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      updateRetirementAgeData({
        spouseRetirementStartAge: Number(e.target.value),
      });
    }
  };

  getMinFinancialEventsStartAge = (financialEvents: any, bpId: any) => {
    const filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId);

    if (filteredFinancialEvents.length === 0) {
      return -1;
    }

    // Find the minimum endNumber among the filtered items
    let minStartNumber = -1;

    if (filteredFinancialEvents[0].startNumber != null) {
      minStartNumber = filteredFinancialEvents[0].startNumber;
    }

    for (const item of filteredFinancialEvents) {
      if (item.startNumber !== null && item.startNumber < minStartNumber) {
        minStartNumber = item.startNumber;
      }
    }

    return minStartNumber;
  };

  getMinFinancialEventsEndAge = (financialEvents: any, bpId: any) => {
    const filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId);

    if (filteredFinancialEvents.length === 0) {
      return -1;
    }

    // Find the minimum endNumber among the filtered items
    let minEndNumber = -1;

    if (filteredFinancialEvents[0].endNumber != null) {
      minEndNumber = filteredFinancialEvents[0].endNumber;
    }

    for (const item of filteredFinancialEvents) {
      if (item.endNumber !== null && item.endNumber < minEndNumber) {
        minEndNumber = item.endNumber;
      }
    }

    return minEndNumber;
  };

  getMaxFinancialEventsStartAge = (financialEvents: any, bpId: any) => {
    const filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId);

    if (filteredFinancialEvents.length === 0) {
      return -1;
    }

    // Find the minimum endNumber among the filtered items
    let maxStartNumber = -1;

    for (const item of filteredFinancialEvents) {
      if (item.startNumber !== null && item.startNumber > maxStartNumber) {
        maxStartNumber = item.startNumber;
      }
    }

    return maxStartNumber;
  };

  getMaxFinancialEventsEndAge = (financialEvents: any, bpId: any) => {
    const filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId);

    if (filteredFinancialEvents.length === 0) {
      return -1;
    }

    // Find the minimum endNumber among the filtered items
    let maxEndNumber = -1;

    for (const item of filteredFinancialEvents) {
      if (item.endNumber !== null && item.endNumber > maxEndNumber) {
        maxEndNumber = item.endNumber;
      }
    }

    return maxEndNumber;
  };

  getEndAgeList = (financialEvents: any, bpId: any, typeName: any, frequency: any) => {
    let filteredFinancialEvents = [];

    if (typeName.toLowerCase() === 'pension') { 
      filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId && item.categoryName.toLowerCase() === 'income' && item.typeName.toLowerCase() === 'pension' && item.frequency === 'MLY');
    } else if (typeName.toLowerCase() === 'annuity') {
      filteredFinancialEvents = financialEvents.filter((item: any) => item.bpId === bpId && item.categoryName.toLowerCase() === 'income' && item.typeName.toLowerCase() === 'annuity');
    }

    if (filteredFinancialEvents.length === 0) {
      return -1;
    }
    
    let endAgeList = [];
    for (const item of filteredFinancialEvents) {
      if (item.endNumber !== null) {
        endAgeList.push(item.endNumber);
      }
    }

    return endAgeList;
  };

  validateInputsAndSubmit = () => {
    const {
      simulationCurrentWant: { participantAge },
      retirementAge: {
        tempScenario: {
          spouseRetirementStartAge,
          retirementEndAge,
          retirementStartAge,
          spouseCurrentAge,
          spouseRetirementEndAge,
          hasSpouse
        },
      },
      hideInputTilePopover,
      modelRetirementAgeScenario,
      updateRetirementAgeError,
      riScenario,
      tempScenarioEvents
    } = this.props;

    // console.log('Inside validateInputsAndSubmit function ================');
    // console.log('Ret start age: ', retirementStartAge);
    // console.log('Ret end age : ', retirementEndAge);
    // console.log('participantAge: ', participantAge);
    // console.log('spouseRetirementStartAge: ', spouseRetirementStartAge);
    // console.log('spouseRetirementEndAge: ', spouseRetirementEndAge);
    

    let participantErrorMessage = '';
    let spouseErrorMessage = '';

    //Now do the validation
    const financialEvents = tempScenarioEvents;
    const participantProfile = riScenario.participantProfile;
    const spouseProfile = riScenario.spouseProfile;

    if (spouseProfile && financialEvents) {
      const fetchedSpouseBbId = spouseProfile.bpId;
      const spouseMinFinancialEventStartAge = this.getMinFinancialEventsStartAge(financialEvents, fetchedSpouseBbId);
      // console.log('spouseMinFinancialEventStartAge: ', spouseMinFinancialEventStartAge);
      const spouseMaxFinancialEventStartAge = this.getMaxFinancialEventsStartAge(financialEvents, fetchedSpouseBbId);
      // console.log('spouseMaxFinancialEventStartAge: ', spouseMaxFinancialEventStartAge);
      const spouseMinFinancialEventEndAge = this.getMinFinancialEventsEndAge(financialEvents, fetchedSpouseBbId);
      // console.log('spouseMinFinancialEventEndAge: ', spouseMinFinancialEventEndAge);
      const spouseMaxFinancialEventEndAge = this.getMaxFinancialEventsEndAge(financialEvents, fetchedSpouseBbId);
      // console.log('spouseMaxFinancialEventEndAge: ', spouseMaxFinancialEventEndAge);

      // Temp FE spouse min start age validation until BE put a solid fix. Use case 4 in DE58903.
      if (spouseRetirementStartAge > spouseMaxFinancialEventStartAge && spouseMaxFinancialEventStartAge != -1) {
        spouseErrorMessage = 'Spouse retirement start age ' + spouseRetirementStartAge + ' can not exceed the event start age ' + spouseMaxFinancialEventStartAge + '\n';
      }

      if (spouseRetirementStartAge > spouseMinFinancialEventEndAge && spouseMinFinancialEventEndAge != -1) {
        spouseErrorMessage = 'Spouse retirement start age ' + spouseRetirementStartAge + ' can not exceed the event end age ' + spouseMinFinancialEventEndAge + '\n';
      }

      // Case 1, From excel grid - FE End Column E
      if (spouseMaxFinancialEventEndAge > 114) {
        spouseErrorMessage = 'You must update one or more financial events before saving your new Retirement end age.';
      }

      // Case 6, From excel grid - FE End Column E
      if (spouseMaxFinancialEventEndAge > retirementEndAge) {
        spouseErrorMessage = 'You must update one or more financial events before saving your new Retirement end age.';
      }
    }

    if (participantProfile && financialEvents) {
      const fetchedParticipantBbId = participantProfile.bpId;
      //now based on the fetchedBbId, get the 
      const participantMinFinancialEventStartAge = this.getMinFinancialEventsStartAge(financialEvents, fetchedParticipantBbId);
      // console.log('participantMinFinancialEventStartAge: ', participantMinFinancialEventStartAge);
      const participantMinFinancialEventEndAge = this.getMinFinancialEventsEndAge(financialEvents, fetchedParticipantBbId);
      // console.log('participantMinFinancialEventEndAge: ', participantMinFinancialEventEndAge);
      const participantMaxFinancialEventEndAge = this.getMaxFinancialEventsEndAge(financialEvents, fetchedParticipantBbId);
      // console.log('participantMaxFinancialEventEndAge: ', participantMaxFinancialEventEndAge);
      const monthlyPensionEndAgeList = this.getEndAgeList(financialEvents, fetchedParticipantBbId, 'Pension', 'MLY');
      const annuityEndAgeList = this.getEndAgeList(financialEvents, fetchedParticipantBbId, 'Annuity', '');
      
      if (retirementStartAge > participantMinFinancialEventStartAge && participantMinFinancialEventStartAge != -1) {
        participantErrorMessage = 'You must update one or more financial events before saving your new Retirement start age.';
      }
      // Temp FE participant minEndAge validation until BE put a solid fix Use case 2 in DE58903
      if (retirementStartAge > participantMinFinancialEventEndAge && participantMinFinancialEventEndAge != -1) {
        participantErrorMessage = 'You must update one or more financial events before saving your new Retirement start age.';
      }

      if (retirementStartAge > participantMaxFinancialEventEndAge && participantMaxFinancialEventEndAge != -1) {
        participantErrorMessage = 'You must update one or more financial events before saving your new Retirement start age.';
      }

      // Temp FE participant minEndAge validation until BE put a solid fix. Use case 3 in DE58903
      if (retirementEndAge < participantMaxFinancialEventEndAge && participantMaxFinancialEventEndAge != -1) {
        participantErrorMessage = 'You must update one or more financial events before saving your new Retirement end age.';
      }

      // Case 1, From excel grid - FE End Column E
      if (participantMaxFinancialEventEndAge > 114) {
        participantErrorMessage += 'You must update one or more financial events before saving your new Retirement end age. > 114';
      }

      // Case 2, From excel grid - FE End Column E
      if (participantMaxFinancialEventEndAge > retirementEndAge) {
        participantErrorMessage = 'You must update one or more financial events before saving your new Retirement end age.';
      }

      // Case 5, From excel grid - FE End Column E
      if (monthlyPensionEndAgeList && monthlyPensionEndAgeList != -1) {
        for (const item of monthlyPensionEndAgeList) {
          if (item != retirementEndAge) {
            participantErrorMessage = 'You must update one or more financial events before saving your new Retirement end age. montly pen != retEndAge';
            break;
          }
        }
      }

      // console.log('annuityEndAgeList: ', annuityEndAgeList);
      /*if (annuityEndAgeList && annuityEndAgeList != -1) { commented out per DE59370
        for (const item of annuityEndAgeList) {
          if (item != retirementEndAge) {
            participantErrorMessage = 'You must update one or more financial events before saving your new Retirement end age.';
            break;
          }
        }
      }*/
    }

    if (participantAge && participantAge.length && participantErrorMessage === '') {
      if (retirementStartAge < participantAge[0]) {
        participantErrorMessage = participantErrorMessage + 'Start age must be equal to or greater than ' + participantAge[0] + '.\n';
      }
      if (retirementStartAge < 18) {
        participantErrorMessage = participantErrorMessage + 'Start age must be 18 or older.\n';
      }
      if (participantAge[0] < 85 && retirementStartAge > 85) {
        participantErrorMessage = participantErrorMessage + 'Start age must be 85 or younger.\n';
      }
      if (participantAge[0] >= 85 && retirementStartAge > participantAge[0] + 1) {
        participantErrorMessage = participantErrorMessage + 'Start age must be one year from now.\n';
      }
      if (retirementEndAge !== '') {
        if (retirementEndAge < retirementStartAge) {
          participantErrorMessage = participantErrorMessage + 'Start age must be before end age.\n';
        }
        if (retirementEndAge > 114) {
          participantErrorMessage = participantErrorMessage + 'End age must be 114 or younger.\n';
        }
        if (retirementStartAge === retirementEndAge) {
          participantErrorMessage = participantErrorMessage + 'Retirement must be one year or longer.\n';
        }
        if (retirementEndAge <= retirementStartAge || retirementEndAge <= participantAge[0]) {
          participantErrorMessage = participantErrorMessage + 'End age must be after your current age and start age.\n';
        }
      }

      if (hasSpouse && spouseRetirementStartAge >= 0) {
        const spouseRetEndAgeBasedOnPpt = retirementEndAge - (participantAge[0] - spouseCurrentAge);
        if ( spouseRetirementStartAge < spouseCurrentAge) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be equal to or greater than ' + participantAge[0] + '.\n';
        }
        if (spouseRetirementStartAge < 18) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be 18 or older.\n';
        }
        if (spouseCurrentAge < 85 && spouseRetirementStartAge > 85) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be 85 or younger.\n';
        } else if (spouseCurrentAge >= 85 && spouseRetirementStartAge > 114) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be 114 or younger.\n';
        } else if (spouseCurrentAge >= 85 && spouseRetirementStartAge > spouseCurrentAge + 1) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be one year from now.\n';
        } else if (spouseRetirementStartAge >= spouseRetirementEndAge) {
          spouseErrorMessage = spouseErrorMessage + 'Start age must be before ' + spouseRetirementEndAge + '.\n';
        } else if (
          spouseRetirementStartAge >= spouseRetirementEndAge ||
          spouseRetirementStartAge >= spouseRetEndAgeBasedOnPpt
        ) {
          spouseErrorMessage =
            spouseErrorMessage +
            'Retirement age must be before ' +
            (spouseRetirementEndAge > spouseRetEndAgeBasedOnPpt ? spouseRetEndAgeBasedOnPpt : spouseRetirementEndAge) +
            '.\n';
        }
      }
    }
    updateRetirementAgeError({
      participantErrorMessage,
      spouseErrorMessage,
    });

    if (!participantErrorMessage && !spouseErrorMessage) {
      modelRetirementAgeScenario();
      hideInputTilePopover();
    }
  };

  render(): JSX.Element {
    const {
      retirementAge: {
        tempScenario: { spouseRetirementStartAge, retirementEndAge, retirementStartAge, hasSpouse },
        error: { participantErrorMessage, spouseErrorMessage },
      },
      retirementAgeAdvice,
    } = this.props;

    return (
      <InputTilePopoverCard
        handleDone={this.validateInputsAndSubmit}
        handleCancel={this.handleCancel}
        analyticsId={analyticsTracking.RIXRetirementAgeInputTileDone}
        cancelId={analyticsTracking.RIXRetirementAgeInputTileCancel}
      >
        <TileHeaderTitle id={`retirement-age-header`}>Retirement Age</TileHeaderTitle>
        <TileSubheader id={`retirement-age-sub-header`}>
          Consider that retirement may last 30 years or more.
        </TileSubheader>
        <AgeRangeContainer id={`retirement-age-container`}>
          <TextContainer id={`retirement-age-your-retirement`}>Your Retirement </TextContainer>
          <InputsContaioner id={`retirement-age-input-container`}>
            <LabelContainer id={`retirement-age-start`}>{'Start'}</LabelContainer>
            <InputWithMessage id={`retirement-start-age-input-container`}>
              <Input
                value={retirementStartAge}
                onChange={this.particStartInputAllowNumbersOnly}
                maxLength={3}
                hasError={participantErrorMessage && participantErrorMessage.includes('Start')}
                textAlign={'center'}
                aria-label={`Retirement start age`}
                id={`retirement-age-input-start-age`}
              />
              {retirementAgeAdvice > 0 && (
                <InputMessage id={`retirement-age-input-try-age`}>Try Age {retirementAgeAdvice}</InputMessage>
              )}
            </InputWithMessage>
            <LabelContainer id={`retirement-age-end`} style={{ paddingLeft: '16px' }}>
              {'End'}
            </LabelContainer>
            <InputWithMessage id={`retirement-end-age-input-container`}>
              <Input
                value={retirementEndAge}
                onChange={this.particEndInputAllowNumbersOnly}
                maxLength={3}
                textAlign={'center'}
                hasError={participantErrorMessage && participantErrorMessage.includes('End')}
                style={{ marginRight: 0 }}
                aria-label={`Retirement end age`}
                id={`retirement-age-input-end-age`}
              />
            </InputWithMessage>
          </InputsContaioner>
        </AgeRangeContainer>
        {participantErrorMessage && <StyledError id={`retirement-age-error`}>{participantErrorMessage}</StyledError>}
        {retirementAgeAdvice > 0 && (
          <Link
            linkLabel={'Why are we suggesting modeling age ' + retirementAgeAdvice + '?'}
            onClick={this.showRetirementAgeModal}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showRetirementAgeModal)}
            color={tokens.ColorBrandInteractiveBlue}
            hoverColor={tokens.ColorBrandInteractiveBlueHover}
            customStyles={'margin-top: 24px'}
            id={`retirement-age-link-elem`}
          />
        )}
        {hasSpouse && (
          <div>
            <Divider />
            <AgeRangeContainer id={`retirement-age-spouse-container`}>
              <TextContainer id={`retirement-age-spouse-text`}>
                Spouse&#39;s Retirement
                <LabelMessage id={`retirement-age-spouse-message`} style={{ width: '226px' }}>
                  We assume your spouse&#39;s retirement will end the same year as yours.
                </LabelMessage>
              </TextContainer>
              <InputsContaioner id={`retirement-age-spouse-input-container`}>
                <LabelContainer id={`retirement-age-spouse-start`}>{'Start'}</LabelContainer>
                <InputWithMessage id={`retirement-spouse-input-container`}>
                  <Input
                    value={spouseRetirementStartAge}
                    onChange={this.spouseInputAllowNumbersOnly}
                    maxLength={3}
                    textAlign={'center'}
                    hasError={!!spouseErrorMessage}
                    style={{ marginRight: 0 }}
                    aria-label={`Spouse retirement start age`}
                    id={`retirement-spouse-start-age`}
                  />
                </InputWithMessage>
              </InputsContaioner>
            </AgeRangeContainer>
            {spouseErrorMessage && <StyledError id={`retirement-spouse-error`}>{spouseErrorMessage}</StyledError>}
          </div>
        )}
      </InputTilePopoverCard>
    );
  }
}

const mapStateToProps = (state: any) => {
  const {
    charts: { simulationCurrentWant },
    retirementAge,
  } = state;
  return {
    simulationCurrentWant,
    retirementAge,
    retirementAgeAdvice: getRetirementAgeAdvice(state),
  };
};

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideInputTilePopover: inputTilesActions.hideInputTilePopover,
  updateRetirementAgeData: retirementAgeActions.updateRetirementAgeData,
  modelRetirementAgeScenario: retirementAgeActions.modelRetirementAgeScenario,
  updateRetirementAgeError: retirementAgeActions.updateRetirementAgeError,
})(RetirementAge);
